import { merge } from '../../helper';

import * as exTable from '../table';

// ----------------------------------------------------------------------------

function start(element: HTMLElement, config: Record<string, any> = {}): void {
    // If table is no table element
    if (!(element instanceof HTMLTableElement)) {
        console.error('Is not an element table...');
        return;
    }

    // Default Config
    const defConfig: Record<string, any> = {
        fnSelect: function (): any {
            // If there is branch
            if (this.hasClass('branch')) {
                return true;
            }
        },
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Select Start
    exTable.select.start(element, defConfig);
}

// ----------------------------------------------------------------------------

export { start };
